import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

import Home from "@/components/Home";
import Recaptcha from "@/components/Recaptcha";

export default new Router({
  routes: [
    { path: "/verify", component: Recaptcha },
    { path: "/", component: Home, beforeEnter: requireRecaptcha },
  ],
});

function requireRecaptcha(to, from, next) {
  // const verified = store.state.recaptchaVerified;
  const verified = true;
  if (!verified) {
    next("/verify");
  } else {
    next();
  }
}
